<template>
  <div class="contract-salesman-dialog">
    <custom-dialog width="900px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" size="small" ref="form" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item :label="$t('crm_contract_salesman_dialog.ye_wu_fu_ze_ren')" prop="salesman" :rules="rules.salesman">
                    <custom-select
                      v-model="form.salesman"
                      url="roleGetUserList"
                      :listener="`${form.partyAId || null}`"
                      width="100%"
                      filterable
                      :isDefault="true"
                      :props="{ label: 'realName', value: 'realName' }"
                      :params="{ orgId: form.partyAId, roleCode: 'SYS_ROLE_SM' }"
                      @change="salesmanChange"
                    ></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('crm_contract_salesman_dialog.ywfzrdh')" prop="salesmanPhone" :rules="rules.salesmanPhone">
                    <el-input v-model="form.salesmanPhone" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <div class="item-title">{{ $t('crm_contract_salesman_dialog.xzxybjdsb') }}</div>
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="table-bd">
            <custom-table
              ref="table"
              type="checkbox"
              :data="deviceList"
              :loading="isLoading"
              :column="tableColumn"
              @filter="filterChange"
              @sort="sortChange"
              v-model="tableSelect"
              height="500px"
            ></custom-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveChoose">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        salesman: '',
        salesmanPhone: '',
        salesmanId: '',
        partyAId: '',
        deviceNoList: [],
        orderId: '',
      },
      tableCode: 'contract_valid_device',
      deviceList: [],
      isLoading: false,
      schemeSelect: [],
      tableSelect: [],
    };
  },
  mounted() {
    this.form.partyAId = this.model.partyAId;
    this.form.orderId = this.model.bizId;
    this.initDialog();
    this.getValidList();
    this.getTableColumn();
    this.rules.salesmanPhone[1].validator = this.$mobilePhoneValidator;
  },

  computed: {
    rules() {
      return {
        salesman: [
          { required: true, message: this.$t('crm_contract_salesman_dialog.qtxywfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 业务负责人
        salesmanPhone: [
          { required: true, message: this.$t('crm_contract_salesman_dialog.qxzywfzrdh') },
          { validator: null, message: this.$t('crm_contract_salesman_dialog.cdyz713gzf') },
        ], // 业务负责人电话
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取关联列表
    getValidList: function () {
      this.isLoading = true;
      // bizClass 40是租售合同要用不一样的接口
      const requestApi = `${this.model.bizClass}` === '40' ? apis.saleOrderDeviceValidList : apis.orderDeviceValidList;
      this.$getJSON(requestApi, { orderId: this.form.orderId }).then((res) => {
        this.isLoading = false;
        this.deviceList = res.data ? res.data : [];
      });
    },
    // 甲方业务负责人
    salesmanChange(item) {
      if (item) {
        this.form.salesman = item.realName || ''; // 甲方项目负责人
        this.form.salesmanPhone = item.mobile || ''; // 联系电话
        this.form.salesmanId = item.userId || ''; // id
      } else {
        this.form.partnerInfo.salesman = ''; // 甲方项目负责人
        this.form.salesmanPhone = ''; // 联系电话
        this.form.salesmanId = '';
      }
    },
    // 保存新增
    saveChoose: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.tableSelect.length) {
          this.$message({
            message: this.$t('crm_contract_salesman_dialog.qxzxybjdsb'),
            type: 'error',
          });
          return;
        }
        this.form.deviceNoList = this.tableSelect.map((i) => i.deviceNo);
        // bizClass 40是租售合同要用不一样的接口
        const requestApi = `${this.model.bizClass}` === '40' ? apis.saleOrderChangeSalesman : apis.contractChangeSalesman;
        this.$postJSON(requestApi, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        });
      });
    },
  },
};
</script>

<style lang="scss">
.contract-salesman-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 16.6%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
